import { RitzAPI, } from '@moderepo/mode-internal-apis';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var ProjectAgentsActionType;
(function (ProjectAgentsActionType) {
    ProjectAgentsActionType["SET_PROJECT_AGENTS"] = "set project agents";
    ProjectAgentsActionType["SET_PROJECT_AGENT"] = "set project agent";
})(ProjectAgentsActionType || (ProjectAgentsActionType = {}));
export const setProjectAgents = (projectId, agents) => {
    return {
        type: ProjectAgentsActionType.SET_PROJECT_AGENTS,
        projectId,
        agents,
    };
};
export const setProjectAgent = (projectId, agent) => {
    return {
        type: ProjectAgentsActionType.SET_PROJECT_AGENT,
        projectId,
        agent,
    };
};
/**
 * Get data for ALL agents in a project
 * @param projectId - The id of the project
 */
export const fetchProjectAgents = (projectId) => {
    return async (dataDispatch) => {
        const agents = await RitzAPI.getInstance().getAllProjectAgents(projectId);
        // project agents loaded successfully, dispatch an action to add it to the state
        await dataDispatch(setProjectAgents(projectId, agents));
    };
};
/**
 * Get 1 agent from a project
 * @param projectId - The id of the project
 */
export const fetchProjectAgent = (projectId, agentId) => {
    return async (dataDispatch) => {
        const agent = await RitzAPI.getInstance().getProjectAgent(projectId, agentId);
        await dataDispatch(setProjectAgent(projectId, agent));
    };
};
/**
 * Create/invite an agent to a project
 * @param projectId - The id of the project
 * @param email - The email of the agent to be invited
 * @param role - The role of the agent to be invited
 */
export const createProjectAgent = (projectId, email, role) => {
    return async () => {
        await RitzAPI.getInstance().createAgent(projectId, email, role);
        // TODO - Maybe clear the agents list
    };
};
/**
 * Remove an agent from a project
 * @param projectId - The id of the project
 * @param agentId - The id of the agent to be removed from the project
 */
export const removeProjectAgent = (projectId, agentId) => {
    return async () => {
        await RitzAPI.getInstance().removeAgent(projectId, agentId);
        // TODO maybe clear the agent list
    };
};
/**
 * Update an agent's role
 * @param projectId - The id of the project
 * @param agentId - The id of the agent to be updated
 * @param role - The agent's new role
 */
export const updateProjectAgentRole = (projectId, agentId, role) => {
    return async (dataDispatch) => {
        await RitzAPI.getInstance().updateAgentRole(projectId, agentId, role);
        await dataDispatch(fetchProjectAgent(projectId, agentId));
    };
};
